import React, { useState, useEffect } from 'react';

const TextAnimation = ({ texts, duration = 3000 }) => {
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % texts.length);
        setFade(true);
      }, 500); // Time for fade-out animation
    }, duration);

    return () => clearInterval(interval);
  }, [texts.length, duration]);

  return (
    <span
      className={`transition-opacity duration-500 ${
        fade ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {texts[index]}
    </span>
  );
};

export default TextAnimation;